// packages/apps/professionals/client/src/components/contacts-search-x/helpers/sort-helper.ts
import {
  SortInfo,
  SortInfoConfig,
  SortOrder,
  getCurrentSortDetails,
  getCurrentSortInfo,
} from "@costar-search-x/core";
import { DeepPartialObject, CoStar } from "@costar-gen/pds-node-client";

import SortType = CoStar.Api.Professional.Locations.LocationSortType;
import { LocationSearchCriteria } from "./types";
import {
  SortDirection,
  sortDirectionToOrder,
  sortOrderToDirection,
} from "../shared/sort-helpers";

const sortOptionsConfig: SortInfoConfig<number> = {
  name: {
    sortField: SortType.LocationName,
  },
  sectorOfActivity: {
    sortField: SortType.PrimarySpecialtyID,
  },
  buildingName: {
    sortField: SortType.BuildingName,
  },
  address: {
    sortField: SortType.Address,
  },
  city: {
    sortField: SortType.City,
  },
  country: {
    sortField: SortType.Country,
  },
  postalCode: {
    sortField: SortType.PostalCode,
  },
  region: {
    sortField: SortType.State,
  },
  numberOfArticles: {
    sortField: SortType.ArticleCount,
    defaultOrder: SortOrder.Descending,
  },
  numberOfLeaseTransactions3Years: {
    sortField: SortType.LeaseTransactionCount3Year,
    defaultOrder: SortOrder.Descending,
  },
  numberOfSaleTransactions3Years: {
    sortField: SortType.SaleTransactionCount3Year,
    defaultOrder: SortOrder.Descending,
  },
  numberOfCollaborators: {
    sortField: SortType.NumberOfEmployees,
    defaultOrder: SortOrder.Descending,
  },
};

const _getCurrentSortDetails = getCurrentSortDetails<number>(sortOptionsConfig);

const _getCurrentSortInfo = getCurrentSortInfo(sortOptionsConfig);

const defaultSortCriteria: LocationSearchCriteria = {
  sort: SortType.CompanyName,
  sortDirection: SortDirection.Ascending,
};

export const getDefaultSortCriteria = () => defaultSortCriteria;

const getCriteriaFromSort = (
  sort: SortInfo | undefined
): DeepPartialObject<LocationSearchCriteria> => {
  const details = _getCurrentSortDetails(sort);
  if (!details) {
    return defaultSortCriteria;
  }
  return {
    sort: details.sortField,
    sortDirection: sortOrderToDirection(details.order),
  };
};

const getSortFromCriteria = (
  criteria: LocationSearchCriteria
): SortInfo | undefined => {
  const sortField = criteria.sort;
  const order = sortDirectionToOrder(criteria.sortDirection);
  return _getCurrentSortInfo({ sortField, order });
};

export const sort = {
  sortOptionsConfig,
  getDefaultSortCriteria,
  getCriteriaFromSort,
  getSortFromCriteria,
};
